import { DoctorProfileModel } from "src/models/doctorProfile";
import { ApiService } from "../apiService";
import { DoctorScheduleDetail } from "src/models/doctorScheduleDetail";
import { Event } from "src/models/event";
import { PatientConsultationModel } from "src/models/waiting";
import { doctorReportModel } from "src/models/doctorReports";
import { PatientHistory } from "src/models/patient-history";
import { doctorEditModel, doctorRequestModel } from "src/models/doctorRequest";
import { OutboundModel } from "src/models/outbound";
import { ApiResponse } from "../apiType";


const apiService = new ApiService();

export const getDoctorById = async (id: string) => await apiService.get<DoctorProfileModel>(`Doctor/GetDoctorById?id=${id}`);

export const updateDoctorById = async (data: any) =>
  await apiService.post<DoctorProfileModel>(
    `Doctor/UpdateDoctor?role=Doctor&actionType=edit`,
    data,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );

// superAdminService.ts
export const updateDoctorBySuperAdmin = async (data: any) =>
  await apiService.post<DoctorProfileModel>(
    `Doctor/UpdateDoctor?role=SuperAdmin&actionType=edit`,
    data,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );

export const getDoctorScheduleById = async(id:string) => await apiService.get<DoctorScheduleDetail[]>(`Doctor/GetSchecduledDetails?id=${id}`);

export const updateAhpraValidity = async(data:any) => await apiService.post<DoctorProfileModel>(`Doctor/UpdateAhpraValidity`,data);

export const getDoctorAvailability = async (id:string) => await apiService.get<Event[]>(`Doctor/GetDoctorAvailability?id=${id}`); 

export const updateDoctorSlots = async(data:any) => await apiService.post(`Doctor/CreateDoctorAvailability`,data);

export const deleteSlot =async(id: string) => await apiService.post(`Doctor/DeleteDoctorAvailability?id=${id}`,{});

export const getWaiting = async(id:string) => await apiService.get<PatientConsultationModel[]>(`Doctor/GetWaitingDetails?doctorId=${id}`);

export const getScheduledDetails = async(id: string) => await apiService.get<PatientConsultationModel[]>(`Doctor/GetScheduledDetails?id=${id}`);

export const getConsultedDetails = async(id: string) => await apiService.get<PatientConsultationModel[]>(`Doctor/GetConsultedDetails?doctorId=${id}`);

export const updateConsultation =async(data: any)=> await apiService.post('Doctor/CreateConsultantDoctor',data);

export const getDoctorHistory =(id:string, startDate?: number, endDate?: number) => {
    let url = `Doctor/GetConsultantDetails?DoctorId=${id}`;
    if (startDate) {
        url += `&startDate=${startDate.toString()}`;
    }
    if (endDate) {
        url += `&endDate=${endDate.toString()}`;
    }
    return apiService.get<doctorReportModel[]>(url);
};

export const generateReportPdf = (consultationId: number) => apiService.get<DoctorScheduleDetail[]>(`Doctor/GenerateReportPdf?consultationId=${consultationId}`);

export const getPatientHistorys =(userId:string) => apiService.get<PatientHistory[]>(`Patient/History?userId=${userId}`);

export const CreateRequest =async(data: any)=> await apiService.post('Doctor/CreateDoctorRequest',data);

export const getDoctorRequest =(id:string) => apiService.get<doctorRequestModel[]>(`Doctor/GetDoctorRequest?id=${id}`);

export const updateConsultationStatus =async(data: any)=> await apiService.post('Doctor/CreateConsultantDoctorStatus',data);

export const getConsultationStatus = async (id: number) => await apiService.get(`Doctor/GetConsultationStatus?id=${id}`);

export const copyAvailabilityToNextMonth = async (doctorId: string, month: string) =>await apiService.post(`Doctor/CopyDoctorAvailabilityToNextMonth`,{ doctorId, month });

export const getAllOutbounds = async (consultationId: string) => await apiService.get<OutboundModel[]>(`Doctor/GetAllOutbounds?consultationId=${consultationId}`);

export const sendOutbounds = async (formData: FormData) => await apiService.post('Doctor/SendOutbounds', formData);

export const completeConsultation = async (data: {
  consultantId: number;
  callStatus: string;
  deliverablesStatus: string;
  deliverablesType: string;
  status: string;
}) => await apiService.post('Doctor/CompleteConsultation', data);

export const getProfileEditChanges =(doctorId:number) => apiService.get<doctorEditModel[]>(`Doctor/GetProfileEditChanges?userId=${doctorId}`);

export interface GPDetailsResponse {
  gpDetails?: string;
  doctorName?: string;
  centerName?: string;
  address?: string;
  suburb?: string;
  postCode?: string;
}

export const getConsultationDetails = async (consultationId: string): Promise<GPDetailsResponse | null> => {
  try {
    // Call the real backend API endpoint
    const response = await apiService.get<GPDetailsResponse>(`Doctor/GetConsultationDetails?consultationId=${consultationId}`);
    
    if (response.ok && response.data) {
      return response.data;
    } else {
      return null;
    }
    
  } catch (error) {
    return null;
  }
};

export const getConsultationPendingStatus = async (id: string) =>
  await apiService.get<ApiResponse<string[]>>(`Doctor/GetConsultationPendingStatus?id=${id}`);
